// src/app/store.ts
import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "../features/api/baseApi";
export const store = configureStore({
    reducer: {
        [baseApi.reducerPath]: baseApi.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(baseApi.middleware),
});
